import { render } from "./approve.vue?vue&type=template&id=1ac5745d&scoped=true"
import script from "./approve.vue?vue&type=script&lang=js"
export * from "./approve.vue?vue&type=script&lang=js"

import "./approve.vue?vue&type=style&index=0&id=1ac5745d&scoped=scoped&lang=css"

import exportComponent from "D:\\www\\ctx\\Uis\\mch\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac5745d"]])

export default __exports__